(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DashboardbetweendatescafDialogController', DashboardbetweendatescafDialogController);

    DashboardbetweendatescafDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Dashboardbetweendatescaf'];

    function DashboardbetweendatescafDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Dashboardbetweendatescaf) {
        var vm = this;

        vm.dashboardbetweendatescaf = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dashboardbetweendatescaf.id !== null) {
                Dashboardbetweendatescaf.update(vm.dashboardbetweendatescaf, onSaveSuccess, onSaveError);
            } else {
                Dashboardbetweendatescaf.save(vm.dashboardbetweendatescaf, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:dashboardbetweendatescafUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.statusDate = false;
        vm.datePickerOpenStatus.formFilledOn = false;
        vm.datePickerOpenStatus.appliedDate = false;
        vm.datePickerOpenStatus.clearedDate = false;
        vm.datePickerOpenStatus.rejectionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
